<template>
  <div class="box">
    <div class="head">
      <div class="headson">
        <img alt="logo" class="logo" src="../../assets/photo/logo.jpg"/>
        <p>找回密码</p>
      </div>
    </div>
    <div class="subject">
      <p class="back" @click="login"><i class="left"></i> 返回</p>
      <div v-show="active==0" class="tipH">找回密码需要验证手机号</div>
      <div v-show="active==1" class="tipH">重新设置密码</div>
      <p v-show="active==0" class="tip">
        如手机号无法正常使用，请联系平台运营(yibao@ciiczj.com) 核实重置密码
      </p>
      <div v-show="active == 0" class="form">
        <el-form
          ref="ruleFormFirst"
          :model="ruleFormFirst"
          :rules="rulesFirst"
          class="demo-ruleForm"
          status-icon
        >
          <el-form-item prop="phone">
            <el-input
              v-model="ruleFormFirst.phone"
              autocomplete="off"
              placeholder="请输入手机号"
              type="tel"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="code"
            style="margin-top: 40px; margin-bottom: 40px"
          >
            <el-input
              v-model="ruleFormFirst.code"
              placeholder="请输入短信验证码"
            >
              <el-button
                slot="append"
                :class="codetype ? 'getcode' : 'notgetcode'"
                @click="getcode"
              >{{ codetype ? "获取验证码" : s + "秒后重新获取" }}
              </el-button
              >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="next"
              type="primary"
              @click="submitFormFirst('ruleFormFirst')"
            >下一步
            </el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div v-show="active==1" class="form">
        <el-form
          ref="ruleFormSecond"
          :model="ruleFormSecond"
          :rules="rulesSecond"
          class="demo-ruleForm"
          status-icon
        >
          <el-form-item label="设置密码" prop="pass">
            <el-input v-model="ruleFormSecond.pass" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input v-model="ruleFormSecond.checkPass" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="next" type="primary" @click="submitFormSecond('ruleFormSecond')"
            >确认
            </el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <p style="color: #000">版权所有：浙江中智经济技术服务有限公司</p>
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        style="cursor: pointer"
        target="_blank"
      >备案号：</a
      >
    </div>
  </div>
</template>
<script>

import {forgetCaptcha, forgetCheckCaptcha, passwordReset} from '@/api/login.js'

export default {
  name: "forgetPassword",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
        const format = reg.test(value);
        if (format) {
          callback();
          //validateField ———— 对部分表单字段进行校验的方法
        } else {
          callback(new Error("请输入正确的手机号"));
        }
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,20}$/;
        const format = reg.test(value);
        if (!format) {
          callback(new Error("英文大小写、数字组合，6-20字符"));
        }
        if (this.ruleFormSecond.checkPass !== "") {
          this.$refs.ruleFormSecond.validateField("checkPass");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleFormSecond.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      active: 0,
      codetype: true,
      s: 60,
      ruleFormFirst: {
        phone: "",
        code: "",
      },
      ruleFormSecond: {
        pass: "",
        checkPass: "",
      },
      rulesFirst: {
        phone: [{validator: validatePhone, trigger: "blur"}],
        code: [{validator: validateCode, trigger: "blur"}],
      },
      rulesSecond: {
        pass: [{validator: validatePass, trigger: "blur"}],
        checkPass: [{validator: validatePass2, trigger: "blur"}],
      },
    };
  },
  mounted() {
  },
  methods: {
    login() {
      this.$router.push({name: "login"});
    },
    getcode() {
      if (this.codetype) {
        this.$refs['ruleFormFirst'].validateField('phone', (valid) => {
          if (!valid) {
            this.codetype = false
            this.timer()
            forgetCaptcha({
              telephone: this.ruleFormFirst.phone
            }).then((response) => {
              if (response.data.success === false) {
                this.$Message.error(response.data.msg)
              } else {
                this.$message({
                  message: '短信验证码发送成功！',
                  type: 'success'
                })

              }
            }).catch(() => {
            })
          } else {
            return false
          }
        })

      }
    },
    timer() {
      let promise = new Promise((resolve, reject) => {
        let setTimer = setInterval(() => {
          this.s = this.s - 1;
          if (this.s <= 0) {
            this.codetype = true;
            this.s = 60;
            resolve(setTimer);
          }
        }, 1000);
      });
      promise.then((setTimer) => {
        clearInterval(setTimer);
      });
    },
    submitFormFirst(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          forgetCheckCaptcha({
            telephone: this.ruleFormFirst.phone,
            captcha: this.ruleFormFirst.code
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
            } else {
              this.active = 1
            }
          }).catch((error) => {
            this.$Message.error(error)
          })
        } else {
          return false;
        }
      });
    },
    resetFormFirst(formName) {
      this.$refs[formName].resetFields();
    },
    submitFormSecond(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          passwordReset({
            telephone: this.ruleFormFirst.phone,
            password: this.ruleFormSecond.pass
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
            } else {
              // this.$alert('密码重置成功', '提示', {
              //   confirmButtonText: '确定',
              //   callback: action => {
              //     this.login(action)
              //   }
              // })
              this.$message({
                message: '密码重置成功',
                type: 'success'
              });
              setTimeout(() => {
                this.login()
              }, 3000);
            }
          }).catch((error) => {
            this.$Message.error(error)
          })
        } else {
          return false;
        }
      });
    },
    resetFormSecond(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  background-color: #fff;
  height: 100vh;

  .steps {
    width: 50vw;
    margin-left: 25vw;
    margin-top: 100px;
    margin-bottom: 100px;
  }

  .head {
    width: 100vw;
    height: 100px;
    box-shadow: 0px 7px 6px 2px rgba(0, 0, 0, 0.09);
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .headson {
      display: flex;
      flex-direction: row;
      color: rgba(16, 16, 16, 1);
      font-size: 20px;

      .logo {
        width: 100px;
        height: 100px;
        margin-left: 50px;
      }

      p {
        line-height: 100px;
        font-weight: 600;
      }
    }

    .query {
      display: flex;
      flex-direction: row;
      font-size: 20px;
      line-height: 100px;
      margin-right: 50px;

      .queryl {
        color: rgba(169, 160, 160, 1);
      }

      .queryr {
        color: rgb(0, 0, 0);
        cursor: pointer;
      }
    }
  }

  .footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 70px;
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    color: #fff;
    // font-weight: bold;
    a {
      cursor: pointer;
      color: #fff;
    }
  }

  .subject {
    width: 506px;
    height: 653px;
    line-height: 20px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 1);
    text-align: center;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
    margin-top: 20px;
    margin-left: calc(50vw - 253px);
    padding-top: 35px;

    .form {
      width: 350px;
      margin-left: 78px;

      .next {
        border-radius: 4px;
        background-color: rgba(0, 123, 211, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 18px;
        height: 50px;
        border-color: #3a62d7;
        width: 100%;
      }

      .getcode {
        background-color: #3a62d7;
        color: #fff;
        margin-top: 0;
        margin-bottom: 0;
        border-radius: 0;
      }
    }

    .tipH {
      width: 376px;
      height: 41px;
      color: rgba(16, 16, 16, 1);
      font-size: 28px;
      text-align: left;
      margin-top: 40px;
      margin-left: 65px;
    }

    .tip {
      width: 376px;
      height: 45px;
      color: rgba(169, 160, 160, 1);
      font-size: 14px;
      text-align: left;
      margin-top: 18px;
      margin-left: 65px;
      margin-bottom: 80px;
    }

    .back {
      cursor: pointer;
      width: 376px;
      margin-left: 65px;
      color: rgba(16, 16, 16, 1);
      font-size: 16px;
      text-align: left;

      i {
        border: 3px solid black;
        border-width: 0px 1px 1px 0px;
        display: inline-block;
        padding: 5px;
      }

      .left {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
    }
  }
}
</style>
